import cx from 'classnames'
import { FC } from 'react'
import { slideReveal, motionGroup } from 'src/hooks/useAppear'
import { colors } from 'src/theme'

import { ArticleCardProps } from '../ArticleCard'
import { BlockTitleProps } from '../BlockTitle'

import * as SC from './styled'

export type ArticlePushProps = {
  className?: string
  cards?: ArticleCardProps[]
  blockTitleProps?: BlockTitleProps
  color?: string
}

const ArticlePush: FC<ArticlePushProps> = ({
  className,
  cards,
  blockTitleProps,
  color = colors.black,
}) => {
  const { motionProps } = motionGroup({ staggerChildren: 0.12 })

  return (
    <SC.Container className={cx('ArticlePush', className)}>
      {blockTitleProps && <SC._BlockTitle {...blockTitleProps} color={color} />}
      {cards && cards.length > 0 && (
        <SC.Cards {...motionProps}>
          {cards.map((card, index) => (
            <SC._ArticleCard key={index} {...card} variants={slideReveal({})} />
          ))}
        </SC.Cards>
      )}
    </SC.Container>
  )
}

export default ArticlePush
